import { unregDevicesAction } from './actions';
import { initialState, make_reducer } from '../../devGroups/reducer_util';

export const unregDevicesReducer = (state = initialState, action) =>
  make_reducer(unregDevicesAction)(state, action);
